import type React from "react";

import { Callout } from "src/design-system/Callout";

export enum DatabaseType {
  SQL = "SQL",
  MongoDB = "MongoDB",
}

export type DatabasePermissionsPillProps = {
  databaseType?: DatabaseType;
};

export const DatabasePermissionsPill: React.FC<
  DatabasePermissionsPillProps
> = ({ databaseType = DatabaseType.SQL }) => {
  return (
    <Callout type="warning">
      <div>
        <span className="text-orange-700 font-inter-semibold-13px">
          Database permissions
        </span>
        <div>
          Taktile will execute the provided {databaseType} queries as-is, with
          no additional permission checks. The security and control of data
          access should be managed in your database settings, following best
          practices to prevent unintended access or data modifications.
        </div>
      </div>
    </Callout>
  );
};
